import React from "react";
import "./Footer.scss";
import {  BsLinkedin,  BsGithub } from "react-icons/bs";
function Footer() {
  return (
    <div className="footer">
      <div className="content">
        <a
          href="linkedin.com/in/muhammad-owais-0b7256230/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a
          href="https://github.com/Owaisdurvesh"
          target="_blank"
          rel="noreferrer"
        >
          <BsGithub />
        </a>
      </div>
      <div className="page">
        <p> Copyright © 2023 Softtechnics</p>
      </div>
    </div>
  );
}

export default Footer;
